
<div id="mainContent">
  <mat-card appearance="outlined">
    <mat-card-content>
      <div class="main fx-row xs-fx-col" >
        <div class="p-r-15 fx-col xs-fx-flex-49-in-col print-fx-flex-49 gt-xs-fx-flex-49">
          <div class="borderBottom p-b-10">
            <span class="color-f-s-23" translate="select_a_shipping"></span>
          </div>
          @if (!isStateRestrict && !utilityService.isEmptyObject(userService.shippingAddress);) {
            <form>
              <div class="p-8 fx-row" flex>
                <address class="color-f-s-14 m-b-0 viewAddress">
                  <span [textContent]="userService.shippingAddress.FirstName + ' '+ userService.shippingAddress.LastName"></span>
                  <br>
                    <span [textContent]="userService.shippingAddress.Street1"></span>, <span
                  [textContent]="userService.shippingAddress.Street2"></span>
                  <br>
                    <span [textContent]="userService.shippingAddress.City"></span>, <span
                  [textContent]="userService.shippingAddress.Region"></span>
                  <span [textContent]="userService.shippingAddress.PostalCode"></span>, <span
                [textContent]="userService.shippingAddress.CountryCode "></span>
              </address>
              <br>
              </div>
              <div class="p-l-5">
                <mat-icon class="p-r-10">mail</mat-icon><span class="mail_position"
              [textContent]="userService.customerData.EmailAddress"></span>
            </div>
            <div class="footerBottom">
              <button mat-button (click)="nextStep();">{{'ship_to_default' | translate}}</button>
            </div>
          </form>
        }
        @if (utilityService.isEmptyObject(userService.shippingAddress);) {
          <span class="no_shipping_address p-t-10"
          >{{'add_shipping_address' | translate}}</span>
        }
      </div>
      <div class="borderLeft xs-fx-flex-1-in-col print-fx-flex-1 gt-xs-fx-flex-1">

      </div>
      <div class="m-top-50 fx-col xs-fx-flex-49-in-col print-fx-flex-49 gt-xs-fx-flex-49">
        <div class="borderBottom">
          <span class="color-f-s-23" translate="add_new_address" (click)="nextStep();" translate="add_new_address"></span>
        </div>
        <div class="p-8 fx-flex-100-in-col">
          <form class="fx-row">
            <div class="fx-col fx-flex-100">
              <div class="fx-row lt-md-fx-col fx-main-between fx-cross-stretch fx-flex-100-in-col">
                <div class="fx-row lt-md-fx-flex-100-in-col print-fx-flex-49 gt-sm-fx-flex-49">
                  <mat-form-field class="ds-validate font-IBM fx-flex" appearance="outline">
                    <mat-label translate="first_name"></mat-label>
                    <input name="firstName" [(ngModel)]="userService.newshippingAddress.FirstName"
                      [ngModelOptions]="{standalone: true}"  validate noempty="true" matInput validate noempty="true">

                  </mat-form-field>
                </div>
                <div class="fx-row lt-md-fx-flex-100-in-col print-fx-flex-49 gt-sm-fx-flex-49">
                  <mat-form-field class="ds-validate font-IBM fx-flex" appearance="outline">
                    <mat-label translate="last_name"></mat-label>
                    <input name="lastName" [(ngModel)]="userService.newshippingAddress.LastName"
                      [ngModelOptions]="{standalone: true}"  matInput validate noempty="true">

                  </mat-form-field>
                </div>
              </div>
              <div class="fx-row fx-flex-100-in-col">
                <mat-form-field class="ds-validate font-IBM fx-flex" appearance="outline">
                  <mat-label [translate]="'Country'">Country</mat-label>
                  <mat-select  [ngModelOptions]="{standalone: true}" [(ngModel)]="userService.newshippingAddress.Country"
                    (selectionChange)="cart1Service.updateCountry({CountryCode: userService.newshippingAddress.Country}, '', false, true); getCountryState(userService.newshippingAddress.Country)" validate noempty="true">
                    @for (country of allowedCountries; track country) {
                      <mat-option
                        [value]="country.CountryCode.toUpperCase()">
                        <img [src]="'https://directscalestring.directscale.com/flags/4x3/'+country.CountryCode+'.svg'"
                          width="18"> {{country.CountryName}}
                        </mat-option>
                      }
                    </mat-select>

                  </mat-form-field>
                </div>
                <div class="fx-row fx-flex-100-in-col">
                  <mat-form-field class="ds-validate font-IBM fx-flex" appearance="outline">
                    <mat-label translate="street_address" ></mat-label>
                    <input name="streetAddress" [(ngModel)]="userService.newshippingAddress.Street1"
                      [ngModelOptions]="{standalone: true}"  matInput validate noempty="true">

                  </mat-form-field>
                </div>
                <div class="fx-row fx-flex-100-in-col">
                  <mat-form-field class="ds-validate font-IBM fx-flex" appearance="outline">
                    <mat-label translate="street_address2"></mat-label>
                    <input name="streetAddress2" [(ngModel)]="userService.newshippingAddress.Street2"
                      [ngModelOptions]="{standalone: true}"  matInput validate noempty="true">

                  </mat-form-field>
                </div>
                <div class="cityStateBox fx-row lt-md-fx-col fx-main-between fx-cross-stretch fx-flex-100-in-col">
                  <div class="fx-row lt-md-fx-flex-100-in-col print-fx-flex-30 gt-sm-fx-flex-30">
                    <mat-form-field class="ds-validate font-IBM fx-flex md-fx-flex-100" appearance="outline">
                      <mat-label translate="city"></mat-label>
                      <input name="city" [(ngModel)]="userService.newshippingAddress.City"
                        [ngModelOptions]="{standalone: true}" matInput validate noempty="true">

                    </mat-form-field>
                  </div>
                  <div class="fx-row lt-md-fx-flex-100-in-col print-fx-flex-30 gt-sm-fx-flex-30">
                    <mat-form-field class="ds-validate font-IBM fx-flex md-fx-flex-100" appearance="outline">
                      <mat-label translate="state"></mat-label>
                      <mat-select [(ngModel)]="userService.newshippingAddress.Region"
                        [ngModelOptions]="{standalone: true}" validate noempty="true">
                        @for (state of states; track state) {
                          <mat-option [value]="state.StateCode">
                            {{state.StateName}}
                          </mat-option>
                        }
                      </mat-select>

                    </mat-form-field>
                  </div>
                  <div class="fx-row lt-md-fx-flex-100-in-col print-fx-flex-33 gt-sm-fx-flex-33">
                    <mat-form-field class="ds-validate font-IBM fx-flex md-fx-flex-100" appearance="outline">
                      <mat-label translate="zip"></mat-label>
                      <input name="zip" [(ngModel)]="userService.newshippingAddress.PostalCode"
                        [ngModelOptions]="{standalone: true}" regxvalidzip="true"
                        [attr.regexcountry]="userService.newshippingAddress.Country" matInput validate noempty="true">

                    </mat-form-field>
                  </div>
                </div>
                <div class="fx-row fx-flex-100-in-col">
                  <mat-form-field class="ds-validate font-IBM fx-flex" appearance="outline">
                    <mat-label translate="phone_number_"></mat-label>
                    <input name="phoneNumber" [(ngModel)]="userService.newshippingAddress.Phone"
                      [ngModelOptions]="{standalone: true}"  matInput validate noempty="true">

                  </mat-form-field>
                </div>
              </div>
            </form>
          </div>
          <div class="footerBottom">
            <button validate trigger-check="true" (success)="nextStep(true);" mat-button>{{'ship_to_this' | translate}}</button>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
